module.exports = __webpack_public_path__ + "static/media/songwriter.c389d12e.svg";